var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGlobe = function SvgGlobe(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7C14.6109 7 16.8974 6.27228 18.419 5.18609L19.581 6.81391C17.6634 8.18272 14.9519 9 12 9C9.04814 9 6.33659 8.18272 4.41901 6.81391L5.58099 5.18609C7.10264 6.27228 9.38907 7 12 7Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17C9.38907 17 7.10264 17.7277 5.58099 18.8139L4.41901 17.1861C6.33659 15.8173 9.04814 15 12 15C14.9519 15 17.6634 15.8173 19.581 17.1861L18.419 18.8139C16.8974 17.7277 14.6109 17 12 17Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9519 18.7492C15.9301 17.1188 16.6 14.7374 16.6 12C16.6 9.2626 15.9301 6.88118 14.9519 5.25082C13.9498 3.58065 12.844 3 12 3C11.156 3 10.0502 3.58065 9.04808 5.25082C8.06987 6.88118 7.4 9.2626 7.4 12C7.4 14.7374 8.06987 17.1188 9.04808 18.7492C10.0502 20.4194 11.156 21 12 21C12.844 21 13.9498 20.4194 14.9519 18.7492ZM12 23C15.6451 23 18.6 18.0751 18.6 12C18.6 5.92487 15.6451 1 12 1C8.35492 1 5.4 5.92487 5.4 12C5.4 18.0751 8.35492 23 12 23Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 21.9V2.1H13V21.9H11Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1 11L21.9 11V13L2.1 13L2.1 11Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGlobe);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/globe.3902879742bb67b496635e1d35114a04.svg";